import { useMutation } from '@tanstack/react-query'
import { useAPI } from '../../../../Contexts/APIContext'

export const useGenerateTags = () => {
  const { generateFeelTags } = useAPI()

  return useMutation({
    mutationFn: data =>
      generateFeelTags({
        ...data,
      }),
  })
}
